import { createContext, useState, type FC, type ReactNode } from "react";

interface UpgradeModalContextType {
  isOpen: boolean;
  showUpgradeModal: () => void;
  hideUpgradeModal: () => void;
}

const UpgradeModalContext = createContext<UpgradeModalContextType | undefined>(
  undefined
);

interface UpgradeModalProviderProps {
  children: ReactNode;
}

const UpgradeModalProvider: FC<UpgradeModalProviderProps> = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);

  const showUpgradeModal = (): void => {
    setIsOpen(true);
  };

  const hideUpgradeModal = (): void => {
    setIsOpen(false);
  };

  const value: UpgradeModalContextType = {
    isOpen,
    showUpgradeModal,
    hideUpgradeModal,
  };

  return (
    <UpgradeModalContext.Provider value={value}>
      {children}
    </UpgradeModalContext.Provider>
  );
};

export { UpgradeModalProvider, UpgradeModalContextType, UpgradeModalContext };
